import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import lineaNegocioApi from '../../../api/lineaNegocioApi';

const EditDashboardDialog = ({ open, handleClose, dashboard }) => {
  const [formData, setFormData] = useState({
    name: dashboard.name,
    url: dashboard.url
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSave = async () => {
    try {
      await lineaNegocioApi.updateDashboard(dashboard.id, formData);
      handleClose();
      alert('¡Dashboard actualizado correctamente!');
    } catch (error) {
      console.error('Error al actualizar el dashboard:', error);
      alert('Error al actualizar el dashboard. Consulta la consola para obtener más detalles.');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Editar Dashboard</DialogTitle>
      <DialogContent>
        <TextField
          label="Nombre referencial"
          variant="outlined"
          fullWidth
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <TextField
          label="URL del Panel de Control"
          variant="outlined"
          fullWidth
          name="url"
          value={formData.url}
          onChange={handleInputChange}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">Cancelar</Button>
        <Button onClick={handleSave} color="primary">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDashboardDialog;
